import toast from 'react-hot-toast';
import { isRequestError } from 'utils/requestError';
import { saveListExcel } from 'utils/tableExport/saveListExcel';
import type { ColumnDef } from '@tanstack/react-table';
import { Card, InputText, TableListData } from 'components';
import { Button, IUseFormStructureItem, InputWraper, useForm } from 'modules';
import React, { useCallback, useState } from 'react';
import {
  useGetCustomersListQuery,
  useGetCustomersListExportQuery,
} from 'services';
import type { GetListCustomerInfoEntity } from 'services/openapi';

import { columnsDefined, type FilterType, getInitFilterValues } from './config';
import { useLocation } from 'react-router-dom';

const CustomersList = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const initFilterValues = getInitFilterValues(urlParams);

  const [variables, setVariables] = useState<FilterType>(initFilterValues);
  const [dataTable, setDataTable] = useState([]);

  const handleFilter = useCallback(
    (e: FilterType) => {
      setVariables({
        ...variables,
        ...e,
        // refreshData: variables.refreshData + 1,
      });
    },
    [variables],
  );

  const filterOptions: IUseFormStructureItem[] = [
    {
      name: 'customerCode',
      label: 'Mã khách hàng',
      defaultValue: initFilterValues?.customerCode,
    },
    {
      name: 'customerName',
      label: 'Tên khách hàng',
      defaultValue: initFilterValues?.customerName,
    },
    {
      name: 'customerPhoneNumber',
      label: 'Số điện thoại',
      defaultValue: initFilterValues?.customerPhoneNumber,
    },
  ];

  const { getInputProps, handleSubmit } = useForm({
    structure: filterOptions,
    onSubmit: handleFilter,
  });

  const { isFetching: isLoadingExport, refetch } =
    useGetCustomersListExportQuery({
      ...variables,
      page: '1',
      pageSize: String(
        (dataTable as unknown as GetListCustomerInfoEntity)?.total,
      ),
    });

  const handleExportExcel = async () => {
    if (isLoadingExport) return;
    try {
      const allData = await refetch({ throwOnError: true });
      await saveListExcel(
        allData.data?.data,
        columnsDefined as ColumnDef<GetListCustomerInfoEntity>[],
        'Danh_sach_khach_hang',
        true,
        {},
      );
    } catch (error) {
      if (!isRequestError(error))
        toast.error(
          error instanceof Error ? error.message : 'Không thể tải danh sách',
        );
    }
  };

  return (
    <>
      <Card className='container-fluid mb20'>
        <form onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-lg-4 col-12'>
              <InputWraper
                inputProps={getInputProps('customerCode')}
                renderInput={InputText}
              />
            </div>

            <div className='col-lg-4 col-12'>
              <InputWraper
                inputProps={getInputProps('customerName')}
                renderInput={InputText}
              />
            </div>

            <div className='col-lg-4 col-12'>
              <InputWraper
                inputProps={getInputProps('customerPhoneNumber')}
                renderInput={InputText}
              />
            </div>
          </div>
          <div className='textCenter mt16 wrapButtonFilter'>
            <Button label={'Tìm kiếm'} type='submit' buttonType='success' />
            <Button
              className='ml15'
              onClick={handleExportExcel}
              label={'Tải về DS'}
              type='submit'
              buttonType='info'
              isLoading={isLoadingExport}
            />
          </div>
        </form>
      </Card>
      <TableListData<GetListCustomerInfoEntity>
        columns={columnsDefined as ColumnDef<GetListCustomerInfoEntity>[]}
        useQuery={useGetCustomersListQuery}
        filterKey='searchDetailContent'
        variables={variables}
        setVariables={setVariables}
        callBackData={setDataTable}
        orderColumn
      />
    </>
  );
};

export default CustomersList;
